import { render } from "./form-target.vue?vue&type=template&id=2cfbf599"
import script from "./form-target.vue?vue&type=script&lang=js"
export * from "./form-target.vue?vue&type=script&lang=js"
script.render = render

export default script